import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import moment from 'moment';
import { API_BASE_URL, API_KEY } from '../../../config/config';
import Breadcrumb from '../../common/Breadcrumb';
import AnalyticsService from '../../../services/analytics';
import Loader from '../../common/Loader';
import { v4 as uuidv4 } from 'uuid';
import './photoalbumlist.scss';
import Layout from '../../Layout/Layout';

const PhotoAlbumList = () => {
  const [state, setState] = useState({
    items: [],
    isLoaded: false,
    error: null
  });
  const { season } = useParams();
  const seasonMap = {
    '2023-24': 11,
    '2024-25': 12,
    '2025-26': 13,
  }

  const getItems = () => {
    const seasonId = seasonMap[season] || 12;

    fetch(`${API_BASE_URL}/photo-album/list?season=${seasonId}`, {
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'X-API-KEY': API_KEY,
        'X-Request-ID': uuidv4()
      }
    })
      .then(res => res.json())
      .then(
        (json) => {
          setState({
            isLoaded: true,
            items: json,
            error: null
          });
        },
        (error) => {
          setState(prev => ({
            ...prev,
            isLoaded: true,
            error
          }));
        }
      );
  };

  useEffect(() => {
    AnalyticsService.sendPageView(window.location.pathname);
    getItems();
  }, [season]);

  const { error, isLoaded, items } = state;

  if (error) {
    return <div>Hiba történt!</div>;
  }

  if (!isLoaded) {
    return (
      <Layout type="slim" cssClassName="photoalbum-container">
        <Breadcrumb />
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h3 className="album-header">Fotóalbumok</h3>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-lg-4 loader-container">
              <Loader />
            </div>
            <div className="col-sm-12 col-lg-4 loader-container">
              <Loader />
            </div>
            <div className="col-sm-12 col-lg-4 loader-container">
              <Loader />
            </div>
            <div className="col-sm-12 col-lg-4 loader-container">
              <Loader />
            </div>
            <div className="col-sm-12 col-lg-4 loader-container">
              <Loader />
            </div>
            <div className="col-sm-12 col-lg-4 loader-container">
              <Loader />
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout type="slim" cssClassName="photoalbum-container">
      <Breadcrumb />

      <section className="main-content">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h3 className="album-header">Fotóalbumok</h3>
            </div>
          </div>
          <div className="row">
            {items.map((item) => (
              <div className="col-sm-12 col-lg-4 album-item" key={item.id}>
                <Link to={`/galeria/${item.id}/0`}>
                  <div>
                    <img src={`${item.photo}`} alt="" />
                  </div>
                  <div>
                    <p>{item.title}</p>
                    <p>{moment(item.created_at).format('YYYY.MM.DD')}</p>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PhotoAlbumList;
